import type { Appearance, LayoutObject } from '@stripe/stripe-js'

export const appearance: Appearance = {
  theme: 'stripe',
  variables: {
    fontFamily: '"DIN Pro Condensed", sans-serif',
    fontWeightBold: '500',
    fontSizeBase: '18px',
    fontSizeXs: '16px',
    colorPrimary: '#2e2e2b',
    borderRadius: '0px'
  },
}

export const paymentElementLayout: LayoutObject = {
  type: 'accordion',
  radios: 'always',
}
